import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";

const FlexControlledRadioGroupSeparatedLabel = ({
	control,
	name,
	label,
	options,
	labelProps,
	className,
	labelStyles,
	inputStyles,
	radioStyles,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => (
				<Box
					sx={{
						display: "flex",
						gap: "10px",
						alignItems: "center",
						width: "100%",
					}}
				>
					<Box
						sx={{
							flex: "0",
							display: "flex",
							alignItems: "center",
							height: "100%",
							...labelStyles,
						}}
					>
						<Typography
							noWrap
							variant="label"
							component="label"
							htmlFor={name}
							sx={{ ...labelProps }}
						>
							{label}:
						</Typography>
					</Box>
					<Box
						sx={{
							flex: "1",
							display: "flex",
							alignItems: "center",
							...inputStyles,
						}}
					>
						<RadioGroup
							className={className}
							row
							aria-labelledby={name}
							{...field}
							{...rest}
							value={field.value || "notExisting"}
						>
							{options.map((option) => (
								<FormControlLabel
									key={option.value}
									value={option.value}
									control={<Radio sx={radioStyles} />}
									label={option.label}
								/>
							))}
						</RadioGroup>
					</Box>
				</Box>
			)}
		/>
	);
};

export default FlexControlledRadioGroupSeparatedLabel;
